import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faCheck, faLock, faTrophy, faRocket, faShieldAlt, faArrowRight, faArrowLeft, faKey } from '@fortawesome/free-solid-svg-icons';
import PlatformVideo from './PlatformVideo';
import {
  PlatformContainer,
  PlatformHeader,
  PlatformIcon,
  PlatformTitle,
  ProgressContainer,
  ProgressBar,
  ProgressFill,
  ProgressText,
  StepsList,
  StepItem,
  StepNumber,
  StepContent,
  StepText,
  StepLink,
  CompletedCheckmark,
  StepToggle,
  StepDescription,
  TechCircle,
  SuccessMessage,
  AnimatedBorder,
  TechGrid,
  DataStream,
  NavigationButtons,
  NavigationButton
} from './PlatformStyles';

const TwilioPlatform = ({ onNavigateToNextPlatform, onUpdateCredential, platformColor }) => {
  const [credentials, setCredentials] = useState({
    twilioAccountSid: '',
    twilioAuthToken: '',
    twilioCallerId: ''
  });
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [fieldsTouched, setFieldsTouched] = useState({
    twilioAccountSid: false,
    twilioAuthToken: false,
    twilioCallerId: false
  });

  const platformUrl = 'https://login.twilio.com/u/signup';
  
  // Checagem se todos os campos estão preenchidos
  const allFieldsFilled = credentials.twilioAccountSid && credentials.twilioAuthToken && credentials.twilioCallerId;


  // Handler para campos
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
    setFieldsTouched(prev => ({ ...prev, [name]: true }));
    if (onUpdateCredential) {
      onUpdateCredential('twilio', name, value);
    }
  };


  // Handler para avançar
  const handleContinue = () => {
    if (!allFieldsFilled) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setIsTransitioning(false);
      if (onNavigateToNextPlatform) onNavigateToNextPlatform();
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 2000);
    }, 800);
  };

  return (
    <PlatformContainer>
      <TechGrid />
      <DataStream />
      <PlatformHeader>
        <PlatformIcon color={platformColor}>
          <FontAwesomeIcon icon={faPhone} />
        </PlatformIcon>
        <PlatformTitle color={platformColor}>Twilio</PlatformTitle>
      </PlatformHeader>
      <PlatformVideo platformId="twilio" platformColor={platformColor} />
      <div style={{ position: 'relative', margin: '1.5rem 0', background: 'rgba(0,0,0,0.25)', borderRadius: 10, padding: 24 }}>
  <AnimatedBorder active={true} color="#F22F46" />
        <div style={{ marginBottom: 18 }}></div>
        <StepLink 
          href={platformUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          color={platformColor}
          style={{ display: 'inline-block', marginBottom: 24 }}
        >
          Acessar Twilio
        </StepLink>
        <div style={{ marginTop: 10 }}>
          <label style={{ color: 'rgba(255,255,255,0.8)', fontWeight: 500 }}>Account SID</label>
          <input
            type="text"
            name="twilioAccountSid"
            placeholder="Account SID"
            value={credentials.twilioAccountSid}
            onChange={handleInputChange}
            style={{ width: '100%', marginBottom: 16, padding: 10, borderRadius: 6, border: `1px solid ${platformColor}`, background: 'rgba(0,0,0,0.3)', color: 'white' }}
          />
          <label style={{ color: 'rgba(255,255,255,0.8)', fontWeight: 500 }}>Auth Token</label>
          <input
            type="text"
            name="twilioAuthToken"
            placeholder="Auth Token"
            value={credentials.twilioAuthToken}
            onChange={handleInputChange}
            style={{ width: '100%', marginBottom: 16, padding: 10, borderRadius: 6, border: `1px solid ${platformColor}`, background: 'rgba(0,0,0,0.3)', color: 'white' }}
          />
          <label style={{ color: 'rgba(255,255,255,0.8)', fontWeight: 500 }}>Verified Caller ID</label>
          <input
            type="text"
            name="twilioCallerId"
            placeholder="5511987654321"
            value={credentials.twilioCallerId}
            onChange={handleInputChange}
            style={{ width: '100%', marginBottom: 16, padding: 10, borderRadius: 6, border: `1px solid ${platformColor}`, background: 'rgba(0,0,0,0.3)', color: 'white' }}
          />
        </div>
        <NavigationButtons style={{ marginTop: 32, display: 'flex', justifyContent: 'flex-end' }}>
          <NavigationButton 
            onClick={handleContinue}
            disabled={!allFieldsFilled || isTransitioning}
            style={{
              opacity: (!allFieldsFilled || isTransitioning) ? 0.5 : 1,
              cursor: (!allFieldsFilled || isTransitioning) ? 'not-allowed' : 'pointer',
              background: `linear-gradient(to right, ${platformColor}, ${platformColor}CC)`,
              color: 'white',
              border: 'none',
              padding: '0.8rem 1.5rem',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontWeight: 600
            }}
          >
            Próxima Plataforma <FontAwesomeIcon icon={faArrowRight} />
          </NavigationButton>
        </NavigationButtons>
        {showConfetti && (
          <SuccessMessage color={platformColor}>
            <FontAwesomeIcon icon={faTrophy} />
            <span>
              <strong>Credenciais salvas!</strong>
            </span>
          </SuccessMessage>
        )}
      </div>
    </PlatformContainer>
  );
};

export default TwilioPlatform;
